import { useState } from 'react';
import WebsiteNavbar from './WebsiteNavbar';
import WebsiteFooter from './WebsiteFooter';
import './Website.css';

const WebsiteContact = () => {
  const [sent, setSent] = useState(false);

  return (
    <div className="website nx nx-refined">
      <WebsiteNavbar />

      <section className="nx-page-hero">
        <div className="nx-kicker">Contact</div>
        <h1>Talk to the index team.</h1>
        <p>Questions on methodology, partnerships or press. We respond within two business days.</p>
      </section>

      <section className="nx-page-body">
        <div className="nx-contact-grid">
          <div className="nx-contact-info">
            <div className="nx-contact-item">
              <h4>Office</h4>
              <p>Lagos, Nigeria</p>
            </div>
            <div className="nx-contact-item">
              <h4>Email</h4>
              <p><a href="mailto:service@thewaacsp.com">service@thewaacsp.com</a></p>
              <p><a href="mailto:Nigeriacsindex@gmail.com">Nigeriacsindex@gmail.com</a></p>
            </div>
            <div className="nx-contact-item">
              <h4>Social</h4>
              <p>
                <a href="https://twitter.com/nigeriacsindex" target="_blank" rel="noopener noreferrer">X (Twitter)</a>
                {' · '}
                <a href="https://www.facebook.com/nigeriacsindex" target="_blank" rel="noopener noreferrer">Facebook</a>
                {' · '}
                <a href="https://www.instagram.com/nigeriacsindex" target="_blank" rel="noopener noreferrer">Instagram</a>
              </p>
            </div>
          </div>

          <div className="nx-contact-form">
            <h3>Send a message</h3>
            {sent ? (
              <p className="nx-form-done">Thank you. Your message has been received. We will reply shortly.</p>
            ) : (
              <form onSubmit={(e) => { e.preventDefault(); setSent(true); }}>
                <div className="nx-form-group">
                  <label htmlFor="name">Full name</label>
                  <input type="text" id="name" name="name" placeholder="Your name" required />
                </div>
                <div className="nx-form-group">
                  <label htmlFor="email">Email address</label>
                  <input type="email" id="email" name="email" placeholder="you@example.com" required />
                </div>
                <div className="nx-form-group">
                  <label htmlFor="subject">Subject</label>
                  <input type="text" id="subject" name="subject" placeholder="How can we help?" />
                </div>
                <div className="nx-form-group">
                  <label htmlFor="message">Message</label>
                  <textarea id="message" name="message" placeholder="Write your message here" required></textarea>
                </div>
                <button type="submit" className="nx-btn nx-btn-primary">Send message</button>
              </form>
            )}
          </div>
        </div>
      </section>

      <WebsiteFooter />
    </div>
  );
};

export default WebsiteContact;
